import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../App";

/** Wraps a route subtree that only makes sense signed in. */
export default function RequireAuth() {
  const { user, loading } = useAuth();

  if (loading) return null; // a beat of nothing beats a flash of the landing page
  if (!user) return <Navigate to="/" replace />;
  return <Outlet />;
}
